import CryptoJS from "crypto-js";
import PageTracker from "../../../../common/PageTrackerHelper";
import VueElementLoading from "vue-element-loading";
import tableTemplate from "../../common/table-template";
import AllocationPopup from "../../CommonAllocation/b-modalsTemplate";
import pendingPods from '../../common/pendingPods';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import pendingGroupIdShipments from '../../common/pendingGroupIdShipments';
import Paginate from 'vuejs-paginate'

import {
    getHubDeliverySRListByHubID as getHubDeliverySRListByHubID,
    getPendingforallocationList as pendingshipmentList,
    AllocatedShipmentDetails as AllocatedFwdShipmentDetails,
    ClientNameList as ClientNameList,
    validateEODAllocation as EODValidation,
    TriDetails as GetTripdetails,
    AllocateShipment as AllocateShipment,
    PreviousDayShipment as PreviousDayShipmentDetails,
    GetHubFlags1 as GetHubFlags2,
    CloseTrip1 as CloseTrip,
    PendingList as PendingList2,
    ServiceType as ServiceType1,
    VehicleList1 as VehicleList,
    CreateTrip as CreateTrip,
    GetSubcluster as SameRouteShipments,
    GetEscalation1 as GetEscalation,
    ShipmentConfirm as ConfirmShipment,
    ShipmentPrintDetails1 as ShipmentPrintDetails,
    pdfData1 as pdfData,
    getUnallocatedShipmentsByShipmentType as getUnallocatedShipments,
    getSameCustomerShipments as getSameCustomerShipmentsforRVP,
    RemoveAllocatedShipment1 as RemoveAllocatedShipment,GetShipmentCount1 as GetShipmentCount,SubmitReason1 as StoreReason,
    SeqofNonAllocation as GetNonAllocationSEQ,
    GetBikeVehicleList as BikeVehicleList
} from '../../../../../services/modules/newallocationservices.js'


import {
    BasicSelect
} from "vue-search-select";
export default {
    name: "FWDAllocation",
    components: {
        Paginate,
        VueElementLoading,
        DatePicker,
        "load-table-template": tableTemplate,
        BasicSelect,
        'pending-Pods': pendingPods,
        "Allocation-Popup": AllocationPopup,
        'pending-group-id-shipment': pendingGroupIdShipments

    },
    mixins: [PageTracker],
    data: function () {
        return {
            userHubIdArr: [],
            value: false,
            PDDPopup: false,
            vehiclePopup: false,
            currentScreenTab: 'ALL',
            CourierCompanyID: '',
            IsSRNeedTrip: false,
            isRSVSr: 0,
            MobileNumber: '',
            OldUserid: '',
            EmpType: '',
            SRSelectingloader: false,
            srArrayList: [],
            srList: [],
            SrId: '',
            SrName: '',
            srItemObj: {
                value: "",
                text: ""
            },
            srLoader: '',
            clientList: [],
            clientArrayList: [],
            Clientname: '',
            ClientObj: {
                value: "",
                text: ""
            },
            Clientname2: '',
            ClientObj2: {
                value: "",
                text: ""
            },
            ClientLoader: '',
            ServiceType: '',
            ServiceTypeArrayList: [],
            ServiceTypeList: [],
            ServiceTypeObj: {
                value: "",
                text: ""
            },
            ServiceLoader: false,
            WeightGroup: '',
            WeightGList: [{
                value: "0,1",
                text: "All"
            },
            {
                value: "1",
                text: "Heavies"
            },
            {
                value: "0",
                text: "Regular"
            },
        ],
            WeightGObj: {},
            EscalationLoader: '',
            Escalation: '',
            EscalationList: [],
            EscalationListArrayList: [],
            EscalationObj: {
                value: "",
                text: ""
            },
            ClusterLoader: '',
            ClusterId: '',
            ClusterList: [],
            ClusterArrayList: [],
            ClusterObj: {
                value: "",
                text: ""
            },
            shipmentNo: '',
            loader: '<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
            showUnallocatedList: [],
            UnallocatedColumns: [
                // {
                //     label: "AWB",
                //     key: "ShippingId",
                // },
                {
                    label: "MPS ID",
                    key: "MultiShipmentGroupID",
                },
                {
                    label: "Client Name",
                    key: "ClientName",
                },
                {
                    label: "Address",
                    key: "CustomerAddress",
                },
                {
                    label: "Pincode",
                    key: "ShipPincode",
                },
                {
                    label: "PDD Date",
                    key: "PDD",
                },
                {
                    label: "Pending Since",
                    key: "PendingSince",
                },
                {
                    label: "No of Reattempt",
                    key: "TotalAttemptCount",
                },
                {
                    label: "Shipment Type",
                    key: "ServiceType",
                },
                {
                    label: "Notification Status",
                    key: "NotificationStatus",
                },
                {
                    label: "Payment Mode",
                    key: "OrderType",
                },
                {
                    label: "Amt",
                    key: "NetPayment",
                },
                {
                    label: "PrexoID",
                    key: "PrexoID",
                },
            ],
            AllocatedList: [],
            AllocatedColumns: [
                // {
                //     label: "AWB",
                //     key: "ShippingID",
                // },
                {
                    label: "MPS ID",
                    key: "MultiShipmentGroupID",
                },
                {
                    label: "Client Name",
                    key: "ClientName",
                },
                {
                    label: "EDD Date",
                    key: "EDD",
                },
                {
                    label: "Pending Since",
                    key: "PendingSince",
                },
                {
                    label: "No of Reattempt",
                    key: "TotalAttemptCount",
                },
                {
                    label: "Shipment Type",
                    key: "ServiceType",
                },
                {
                    label: "Pincode",
                    key: "ShipPincode",
                },
                {
                    label: "PrexoID",
                    key: "PrexoID",
                },
            ],
            SuggestionList: [],
            SuggestionColumns: [
                // {
                //     label: "AWB",
                //     key: "ShippingID",
                // },
                {
                    label: "Client Name",
                    key: "ClientName",
                },
                {
                    label: "No of Reattempt",
                    key: "TotalAttemptCount",
                },
                {
                    label: "NDR Reason",
                    key: "NDRReason",
                },
                {
                    label: "PDD date",
                    key: "PDD",
                },
                // {
                //     label: "Cluster ID",
                //     key: "SubClusterId",
                // },
                {
                    label: "SubCluster Name",
                    key: "SubClusterName",
                },
                {
                    label: "PrexoID",
                    key: "PrexoID",
                },
            ],
            SameRouteColumns: [
                // {
                //     label: "AWB",
                //     key: "ShippingID",
                // },
                {
                    label: "Client Name",
                    key: "ClientName",
                },
                {
                    label: "No of Reattempt",
                    key: "TotalAttemptCount",
                },
                {
                    label: "NPR Reason",
                    key: "NDRReason",
                },
                {
                    label: "EDD date",
                    key: "EDD",
                },
                // {
                //     label: "Cluster ID",
                //     key: "SubClusterId",
                // },
                {
                    label: "SubCluster Name",
                    key: "SubClusterName",
                },
                {
                    label: "PrexoID",
                    key: "PrexoID",
                },
            ],
            SameRouteList: [],
            startAllocationFlag: false,
            AllocateLoading: false,
            isAllocation: false,
            isConfirmLoad: false,
            dismissSecs: 20,
            dismissCountDown: 0,
            allocationErrorMsg: "",
            dismissCountDownSuccess: 0,
            allocationSuccessMsg: "",
            flagShowPreviousShipment: false,
            showShipmentModel: false,
            isPodsLoader: false,
            PendingList: [],
            showGroupIdShipmentModel: false,
            showParentGroupIdShipmentList: [],
            pendingGrouptErrorMsg: '',
            IsLongPinCodeFlag: null,
            ebnVehicleNo: '',
            errEbnVehicleNo: '',
            flagShowEbnVehicleNo: false,
            closeTripModel: false,
            startTripFlag: false,
            tripId: '',
            openKmImg: '',
            openKm: '',
            closeKmImg: '',
            closeKm: '',
            errorOpenKM: '',
            errorCloseKM: '',
            originCloseImg: '',
            srVehicleNo: '',
            tripTitle: 'Start Trip',
            tripCreatedDate: '',
            currentDateTime: '',
            tripDayflag: 0,
            tripDateFlag: false,
            vehicleTypeFlag: false,
            vehicleNo: '',
            vehicleOpenKM: '',
            errVehicleNo: '',
            vehicleTypeFlag: false,
            vehicleType: '',
            srVehicleList: [],
            vehicleNoItemObj: {
                value: '',
                text: ''
            },
            errVehicleKm: '',
            isVehicleReplacedCheck: 0,
            isVehicleReplaced: false,
            vehicleVendorId: '',
            allocationLoader: false,
            PrintShipmentModal: false,
            batchCreatedDate: '',
            PrintShipmentsList: [],
            PrintShipmentsColumns: [{
                    label: "Delivery User",
                    key: "SrName",
                },
                {
                    label: "Created Date",
                    key: "CreatedDate",
                },
            ],
            ShowPrintTable: false,
            isLoadPDF: false,
            isLoadBatch: false,
            shippingIDArray: [],
            ResCreatedDate: '',
            EnableHyperLink: false,
            unallocatePageNumber: 1,
            unallocatePageLimit: 10,
            unallocateTotalCount: 0,
            unallocatepageCount: 1,
            AccAWBNumbers: '',
            showAllocatedShipmentsList: [],
            srallocatePageNumber: 1,
            srAllocatedTotalCount: 0,
            srAllocatedPageCount: 1,
            srAllocatedPageLimit: 10,
            huballocatePageNumber: 1,
            hubAllocatedTotalCount: 0,
            hubAllocatedPageCount: 0,
            hubAllocatedPageLimit: 10,
            IsAllData: true,
            Tobeattempted: false,
            Pddbreached: false,
            Pddbreachedinnext24hours: false,
            FakeAttempt: false,
            disableprint:false,
            PDLoading:false,
            SMLoading: false,
            UNLoading:false,
            UASelectedArr :[],
            PDSelectedArr:[],
            SMSelectedArr:[],
            AllCount:0,
            pddBreachedCount:0,
            PDDBreachedinNext24hrsCount:0,
            fakeAttemptsCount:0,
            tobeAttemptedTodayCount:0,
            CountLoading:false,
            errorRvpAllocation: '',
            successRvpAllocation: '',
            suggestRVPArrayList: '',
            morePendingRVPShipmentsModel: false,
            IsrvpMPSAllocation: false,
            sAllMoreShip: '',
            selectedPickupsMore: '',
            isLoadingASL: false,
            sameCustomerTitle: 'Shipments belongs to same customer',
            rvpAddress: '',
            holdTempMPSData: [],
            IsrvpMPSAllocation: false,
            mpsErrorLabel: 'Below highlighted shipments are from same mps group , Please allocate them to same SR.',
            hideAllocateFlag: true,
            isLoadingRvpPickup: true,
            resArray: [],
            showParentGroupIdShipmentListLoader: false,
            IsRVPPaperless: false,
            TopReset : true,
            AllocateTableLoader: false,
            PDTableLoader:false,
            SMTableLoader:false,
            UATableLoader:false,
            HUbAllocatedTableLoader:false,
            continueloader:false,
            PassEOD:false,
            shippingData:[],
            VehicalNo:0,
            EBNshippingData: [],
            vehicleNumbers: {},
      storeAns: [],
      NonAllocationRsn: false,
            Reason: '',
            ReasonList: [],
            ReasonObj: {
                text: ""
            },
            BucketName: '',
            selectedItems: [],
            TitleName:'',
            IsReload: false,
            fromList:[{ value: "UA",text: "From Mobile"},{ value: "Web",text: "From Web"}],
            fromItemObj:{ value: "UA",text: "From Mobile"},
            fromId:"UA",
            ebnDataLoader: false,
            vehicleNoRegExp : /^([A-Z|a-z]{2,3}\s{1}[0-9]{1,2}\s{1}[A-Z|a-z]{1,2}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,2}[A-Z|a-z]{1}\s{1}[A-Z|a-z]{1,2}\s{1}\d{4})?([A-Z|a-z]{3}\s{1}\d{1,4})?([A-Z|a-z]{2,3}\s{1}[0-9]{2}\s{1}\d{4})?([A-Z|a-z]{2}\s{1}[0-9]{1,3}\s{1}[A-Z|a-z]{1,3}\s{1}\d{4})?$/,
            ResetLoader:false,
            resultCount: 0,
            SEQShippingids: [],
            rvpPrexoShipmentList:[],
            rvpPrexoShipMsg: 'This is a PREXO shipment, and its associated Delivery shipment is :- ',
            rvpPrexoShipMsgBulk: 'You have allocated some prexo shipments, find below associated Delivery shipments :- ',
            userDataKey : '',
        };
    },
    filters: {
        batchCreatedDateFormat: function (date) {
            if (date == null) return ''
            return moment(date).format('DD-MM-YYYY');
        }
    },
    created() {
      this.GetClientList();
      this.GetServiceTypeList();
      this.GetEscalation();
    },
    async mounted() {
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        let validateUser = await this.validateJwtToken();
        var userdetailEncrypt = window.localStorage.getItem("lmaccessuserdata");
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.createdBy = userdetail.username;
        this.userid = userdetail.userid;
        this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0];
        this.loadUnallocatedShipmentsList();
        this.loadAllocatedShipmentListInHub()
        this.GetCount();
                let vm = this;
        Promise.all([
          this.GetHubFlags(vm.userHubId),
          this.GetDeliverySRList(vm.userHubId),
        ])
        .then((promresult) => {
          console.log('promresult ->', promresult);
        })
        .catch((err) => {
          console.log('error in page load functions', err);
        })
        // this.vehicleNoRegExp = new RegExp('^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$');

        const IsRVPPaperlessEncrypt = window.localStorage.getItem('IsRVPPaperless')
        const IsRVPPaperlessbytes = CryptoJS.AES.decrypt(IsRVPPaperlessEncrypt.toString(), this.userDataKey);
        const IsRVPPaperlessbytestext = IsRVPPaperlessbytes.toString(CryptoJS.enc.Utf8);
        const paperLessKey = JSON.parse(IsRVPPaperlessbytestext)
        //console.log('paperLessKey',paperLessKey);
        if(paperLessKey != null && paperLessKey.trim() == "1") {
          this.IsRVPPaperless = true;
          this.deliveryOptionListPrint.splice(2, 1) ;
        } else {
          this.IsRVPPaperless = false;
        }
        console.log('this.IsRVPPaperless',this.IsRVPPaperless);
    },
    methods: {
      loadRVPShipmentDetails(event){
        console.log('Start');
        this.UNLoading = true;
        if(this.ClientObj.text) {
          let searchvalue = this.ClientObj.text.toLowerCase();
          $(".rvpunAllocatedList .table-bordered tbody tr").filter(function() {
            $(this).toggle($(this).text().toLowerCase().indexOf(searchvalue) > -1)
          });
        }
        if (this.ServiceTypeObj.text) {
          let searchvalue = this.ServiceTypeObj.text.toLowerCase();
          $(".rvpunAllocatedList .table-bordered tbody tr").filter(function() {
            $(this).toggle($(this).text().toLowerCase().indexOf(searchvalue) > -1)
          });
        }
        if (this.rvpAddress) {
          let searchvalue = this.rvpAddress.toLowerCase();
          $(".rvpunAllocatedList .table-bordered tbody tr").filter(function() {
            $(this).toggle($(this).text().toLowerCase().indexOf(searchvalue) > -1)
          });
        }
        if (this.AccAWBNumbers) {
          let searchvalue = this.AccAWBNumbers.toLowerCase();
          $(".rvpunAllocatedList .table-bordered tbody tr").filter(function() {
            $(this).toggle($(this).text().toLowerCase().indexOf(searchvalue) > -1)
          });
        }
        this.UNLoading = false

      },
      selectAllMoreRVPShipments(){

      },
      closeRvpShipmentsModel() {
        this.morePendingRVPShipmentsModel = false;
      },
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    countDownChangedSuccess(dismissCountDownSuccess) {
        this.dismissCountDownSuccess = dismissCountDownSuccess
    },
      allocatePickups(){
        if(this.SrId != '') {
          if(this.PassEOD == false){
            this.$alertify.error('Day end closure has not been performed by selected SR.!')
          }else{
          this.UNLoading = true;
          this.selectedPickupsMore=[]
          this.getPendingForRVPList().then( (result) => {
            if(result.success) {
            this.morePendingRVPShipmentsModel = true
            this.isActiveRvp=true
            this.UNLoading = false;
            } else {
              this.allocatePickup()
              this.UNLoading = false;
            }
          });
        }
        } else {
          this.$alertify.error('Please select SR to allocate shipments.!')
        }
      },
      selectAllMoreRVPShipments() {
                if (this.sAllMoreShip) {
          this.suggestRVPArrayList.forEach((data) => {
            this.selectedPickupsMore.indexOf(data.ShippingId) == -1 ? this.selectedPickupsMore.push(data.ShippingId) : ''
          })
        } else {
          this.selectedPickupsMore = []
        }
      },
      getPendingForRVPList() {
        this.errorRvpAllocation = "";
        this.successRvpAllocation = '';
        return new Promise( (resolve, reject) => {
          this.suggestRVPArrayList = []
          var relShippingIds = []
          let reqPayload = {ShippingID:this.UASelectedArr}
          getSameCustomerShipmentsforRVP(reqPayload,(response) => {
            try{

              var resultData = response.data
              if(resultData.code == 200 && typeof resultData.data !== 'undefined') {
                var result = resultData.data
                for (var i = 0; i < result.length; i++) {
                  if(result[i].ReversePickUpData.length>0) {
                    let tempData = result[i].ReversePickUpData
                    for (var j = 0; j < tempData.length; j++) {
                      relShippingIds.push(tempData[j])
                    }
                  }
                }

                if(relShippingIds.length>0) {
                  for (var i = 0; i < relShippingIds.length; i++) {
                    for (var j = 0; j < this.UASelectedArr.length; j++) {
                      if(relShippingIds[i]==this.UASelectedArr[j]) {
                        console.log('Success', relShippingIds[i]);
                        relShippingIds.splice(i,1);
                        // i = i-1;
                      }
                    }
                  }
                  var uniqueArray = []
                  for (var i = 0; i < relShippingIds.length; i++) {
                    if(uniqueArray.indexOf(relShippingIds[i]) === -1) {
                      uniqueArray.push(relShippingIds[i]);
                    }
                  }

                  var suggestRVPArrayList=[]
                  console.log('uniqueArray ---------->>', uniqueArray);
                  for (var i = 0; i < this.showUnallocatedList.length; i++) {
                    if(uniqueArray.includes(this.showUnallocatedList[i].ShippingId)) {
                      this.suggestRVPArrayList.push(this.showUnallocatedList[i]);
                    }
                  }
                  resolve({success:true});
                }
              } else {
                resolve({success:false});
              }

           } catch(e) {
             console.log('result------', result);
             console.log('ERRORRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRR', e);
           }
         })
        });
      },
      preMPSValidationCheck() {
        this.continueloader = true
        this.getSameMPSGroupShipments().then( (result) => {
          if(result.success) {
            this.morePendingRVPShipmentsModel = true
            this.isActiveRvp=true
            if(this.IsrvpMPSAllocation) {

              let mpsGroupShipments = this.holdTempMPSData
              let mpsCount = mpsGroupShipments.length
              if(mpsGroupShipments.length > 0) {
                let filterArray = mpsGroupShipments.filter(person => this.selectedPickupsMore.includes(person.ShippingId) );
                if(filterArray.length == mpsGroupShipments.length) {
                  console.log('Proceed For Success.!!!!!!!!!!');
                  this.allocatePickup()
                } else {
                  this.sameCustomerTitle = 'Mandatory to allocate MPS Shipments.'
                  this.$alertify.error('Please allocate same mps shipment to one SR.!')
                }
              } else {
                this.allocatePickup()
                console.log('Proceed Without MPS Success.!!!!!!!!!!');
              }
            }
            this.continueloader = false
          } else {
            this.isLoadingASL = true;
            this.allocatePickup()
            this.continueloader = false
          }
        });
      },
      getSameMPSGroupShipments() {
        this.IsrvpMPSAllocation = false
        return new Promise((resolve, reject) => {
          let holdTempData = []
          this.holdTempMPSData = []
          let len = this.UASelectedArr.length;
          for(let i = 0; i< len; i++) {
            let getObj = this.showUnallocatedList.find(obj => obj.ShippingId == this.UASelectedArr[i])
            if(getObj && getObj != 'undefined'){
              let mpsShipments = this.showUnallocatedList.forEach(mpscheck => {
                if (mpscheck.MultiShipmentGroupID != '' && mpscheck.MultiShipmentGroupID != null && mpscheck.MultiShipmentGroupID != 'null' &&  mpscheck.MultiShipmentGroupID == getObj.MultiShipmentGroupID) {
                  if(!this.UASelectedArr.includes(mpscheck.ShippingId)) {
                    if(this.holdTempMPSData.length>0){
                      let isExist = this.holdTempMPSData.find(o=>o.ShippingId == mpscheck.ShippingId)

                      if (isExist){
                      }else{
                        this.holdTempMPSData.push(mpscheck);

                      }

                    }else {this.holdTempMPSData.push(mpscheck);}

                  }
                }
              })
            }
          }

          if(this.holdTempMPSData.length > 0) {
            this.IsrvpMPSAllocation = true
            this.suggestRVPArrayList = this.holdTempMPSData
            resolve({success:true});
          } else {
            this.IsrvpMPSAllocation = false
            resolve({success:false});
          }
        })
      },
      selectedItemdataEvent(selectedItems){
        this.selectedItems = [];
        this.UASelectedArr = []
         this.selectedItems = selectedItems
        for(let i=0;i < this.selectedItems.length;i++){
         this.UASelectedArr.push(this.selectedItems[i].ShippingId)
        }
        },

      async allocatePickup() {
        try {
        this.IsReload = true;
        let validateUser = await this.validateJwtToken()
        this.UASelectedArr = this.UASelectedArr.concat(this.selectedPickupsMore)
        var self = this;
        this.errorRvpAllocation = "";
        this.successRvpAllocation = '';
        this.errorRvpAllocationErrorArrobj = [];
        this.ShipmentFutureFailedArrObj = [];
        this.ShipmentFailedArrObj = [];
        this.EBNshippingData = []
        if(this.UASelectedArr.length>0) {
          this.resArray = [];

          var successCount = 0;
          var failCount = 0;
          var failCountFutureDate = 0;
          var failShipmentsFDArray = [];
          var failShipmentsArray = [];
          let tempEbnShipments = [];
          let chain = Promise.resolve();
          for(let val of this.UASelectedArr) {
            chain = chain.then(() => self.bulkAllocation(val));
          }
          chain.then(() => {
            var result = this.resArray
            this.vehiclePopup = false

            for (var i = 0; i < result.length; i++) {
              if (result[i].statusCode==206) {
                failShipmentsFDArray.push(result[i].shippingId)
                failCountFutureDate++;
                this.ShipmentFutureFailedArrObj.push(result[i]);
              }
              else if(result[i].statusCode==207) {
                this.EBNshippingData.push({shippingId: result[i].shippingId})
                tempEbnShipments.push(result[i].shippingId);
              }
              else if (result[i].statusCode==200) {
                successCount++;
                if(result[i].prexoShipment){
                    this.rvpPrexoShipmentList.push(parseInt(result[i].prexoShipment));
                }
              } else {
                failCount++;
                this.ShipmentFailedArrObj.push(result[i]);
              }
            }
            if(failCount>0) {
            this.dismissCountDown = 10
              self.errorRvpAllocation = failCount+" shipping ids cannot assign for pickup."
              this.errorRvpAllocationErrorArrobj = this.ShipmentFailedArrObj;
            }
            if(failCountFutureDate>0) {
            this.dismissCountDown = 10
              self.errorRvpAllocation = failCountFutureDate+" these shipping ids cannot assign for pickup, because pickup date set as a future date.";
              this.errorRvpAllocationErrorArrobj = this.ShipmentFutureFailedArrObj;
            }
            if(successCount>0) {
              this.dismissCountDownSuccess = 10;
              self.successRvpAllocation = successCount+" shipments allocated successfully";
            }

            this.IsReload = false;
            this.ebnDataLoader = false
            this.rvpAddress = ''
            this.isLoadingASL = false
            if(this.EBNshippingData.length > 0) {
              this.morePendingRVPShipmentsModel = false
              this.vehiclePopup = true
              this.isActiveRvp=false
              this.UASelectedArr = tempEbnShipments
              return true
            }
            // this.AllocatedFwdShipmentData();
            this.loadAllocatedShipmentListInHub();
            this.loadUnallocatedShipmentsList();
            this.GetCount();
            this.isAllocationRvp = true;
            this.morePendingRVPShipmentsModel = false
            this.isActiveRvp=false
            this.clearallocationFields();
          }).catch(err=>{
            console.log('promise Error', err);
            self.errorRvpAllocation = err.message;
          });
        }
      }catch(e) {
        console.log('Error in allocation page', e);
      }
      },
      loadAllocatedDetails(){
        this.AllocatedFwdShipmentData();
    },

    SaveEBNData(scope) {
        this.errVehicleNo = "";
        this.$validator.validateAll(scope).then(result => {
          if(result) {
            this.ebnDataLoader = true
            this.allocatePickup()
          } else {
            console.log('failed Success ebn',this.$validator);
          }
        })
        .catch(() => {
          console.log('errors exist', this.errors)
        });
      },
      closevehiclePopup(){
        this.storeAns = []
        this.EBNshippingData = []
        this.vehicleNumbers = {}
        this.vehiclePopup = false
        },
      bulkAllocation(shippingId) {
            try {
            this.IsReload = true;
          return new Promise( (resolve, reject) => {
            this.files = []
            var selectedSrDtl = this.srArrayList.filter(n=>{
              return n.userid==this.SrId
            })

            this.input = {
              "isAllocationFrom":'New',
              "XBkey":"XB123",
            	"HubId":this.userHubId.toString(),
            	"DeliveryUserId":this.SrId,
            	"OldDeliveryUserOrUserId":selectedSrDtl[0].OldDeliveryUserOrUserId?selectedSrDtl[0].OldDeliveryUserOrUserId.toString():"0",
            	"DeliveryUserName":this.SrName,
            	"ShippingID":shippingId,
            	"LastModifiedBy":this.createdBy,
            	"IsConfirmAllocation":false,
            	"AllocationType":'RVP',
              "EmpType":selectedSrDtl[0].EmpType?selectedSrDtl[0].EmpType:"",
            	"MarkedFrom":"Web",
            	"CourierCompanyID":selectedSrDtl[0].CourierCompanyID?selectedSrDtl[0].CourierCompanyID.toString():'null',
            	"IsRSVCSr":this.isRSVSr,
            	"MobileNo":selectedSrDtl[0].MobileNumber?selectedSrDtl[0].MobileNumber.toString():"",
              "isTripAllowedForSR": this.IsSRNeedTrip,
              "IsRVPPaperless": this.IsRVPPaperless,
              "vehicleno": this.vehiclePopup ? this.vehicleNumbers[shippingId] : undefined
            }

            AllocateShipment(this.input, (result) => {
              var result = result.data
                //Hundle Prexo shipment error and succes msg
                let finalObjOfErrorOrSuccess = {"success":false, "statusCode":result.status, "message":result.message, "shippingId":shippingId}
                if(result.prexoShipment){
                    finalObjOfErrorOrSuccess['prexoShipment']=result.prexoShipment
                }
              if(result.status==204) {
                this.resArray.push(finalObjOfErrorOrSuccess);
                resolve({"success":false, "statusCode":result.status, "message":result.message, "shippingId":shippingId});
              } else if (result.status==206) {
                this.resArray.push(finalObjOfErrorOrSuccess)
                resolve();
              } else if(result.status==207) {
                //ebn condition.
                this.resArray.push(finalObjOfErrorOrSuccess);
                resolve();
              } else if (result.code==200) {
                                // $("#rvpTr"+shippingId).remove();
                let TrackerInfo = {
                  projectname:"Last Mile",
                  type:"Web",
                  userid:this.userid,
                  username:this.createdBy,
                  meta: {
                      "event" : "bulkAllocation",
                      "HubId":this.userHubId.toString(),
                      "DeliveryUserId":this.SrId,
                      "ShippingID":shippingId.toString()
                  }
                }
                this.PageTracker(TrackerInfo);
                for (var i = 0; i < this.UASelectedArr.length; i++) {
                if(this.UASelectedArr[i]==shippingId) {
                this.UASelectedArr.splice(i, 1);
                }
                }
                this.isAllocation = true
                finalObjOfErrorOrSuccess.success = true;
                finalObjOfErrorOrSuccess.statusCode = result.code;
                this.resArray.push(finalObjOfErrorOrSuccess)
                resolve();
              } else {
                finalObjOfErrorOrSuccess.statusCode = result.code;
                this.resArray.push(finalObjOfErrorOrSuccess)
                resolve();
              }
              this.IsReload = false;

            })
          })
        } catch(e) {
          console.log('Exit error', e);
        }
      },
      clearallocationFields(){
        this.IsReload = false;
        this.selectedPickupsMore = []
        this.suggestRVPArrayList = []
        this.morePendingRVPShipmentsModel = false
        this.IsrvpMPSAllocation = false
        this.sAllMoreShip = []
        this.UASelectedArr = []
        this.loadUnallocatedShipmentsList();
      },
        selectSR(obj) {
            this.dismissCountDown = 0;
            this.dismissCountDownSuccess = 0;
            this.errorRvpAllocation = "";
            this.successRvpAllocation = '';
            this.errorRvpAllocationErrorArrobj = [];
            this.isAllocation = false
            this.srItemObj = obj;
            this.SrId = obj.value;
            this.SrName = obj.text;
            this.OldUserid = obj.OldUserid;
            this.EmpType = obj.EmpType;
            this.CourierCompanyID = obj.CourierCompanyID;
            this.MobileNumber = obj.MobileNumber;
            this.IsSRNeedTrip = obj.IsSRNeedTrip;
            this.vehicleTypeFlag = false;
            this.tripDayflag = 0;
            this.disableprint = true;
            this.AllocatedFwdShipmentData();
            this.PreviousDayShipmentList();
            this.SameRouteShipmentList();
            this.validateEODAllocation();
            if (this.EmpType == null || this.EmpType == "") {
                this.$alertify.error("EmpType not found against this SR, EmpType is required.")
            } else if (this.IsSRNeedTrip == true) {
                this.TopReset = false
                this.IsSRNeedTrip = true
                this.tripDayflag = 0;
                this.SRSelectingloader = true;
                this.vehicleType = ""
                this.srVehicleList = []
                this.vehicleNoItemObj = {
                    value: '',
                    text: ''
                }
                this.vehicleOpenKM = ''
                this.vehicleNo = ''
                this.vehicleVendorId = 0
                this.startAllocationFlag = false
                this.tripTitle = 'Start Trip'
                this.errorCloseKM = ''
                this.errorOpenKM = ''
                this.closeKm = ''
                this.tripState = ''
                this.ValiadteTripdetails();
            }
        },
         GetDeliverySRList(hubid) {
           return new Promise((resolve,reject) => {
             try {
               this.srLoader = this.loader;
               this.srArrayList = [];
               this.srList = [];
               let RVPPayload = {
                   "usertype": "3",
                   "hubid": [hubid]
               }
                getHubDeliverySRListByHubID(RVPPayload,(result) => {
                  try{

                   this.srArrayList = result.data.data.results;
                   for (var i = 0; i < this.srArrayList.length; i++) {
                       this.srList.push({
                           value: this.srArrayList[i].userid,
                           text: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName} (${this.srArrayList[i].OldDeliveryUserOrUserId}) (${this.srArrayList[i].userid})`,
                           OldUserid: this.srArrayList[i].OldDeliveryUserOrUserId,
                           EmpType: this.srArrayList[i].EmpType,
                           CourierCompanyID: this.srArrayList[i].CourierCompanyID,
                           MobileNumber: this.srArrayList[i].MobileNumber,
                           IsSRNeedTrip: this.srArrayList[i].isTripAllowedForSR
                       })
                   }
                   this.srLoader = '';
                 } catch(e) {
                   console.log('result------', result);
                 }
               })
              resolve(true);
             } catch(err) {
               console.log('Error Logs forGetDeliverySRList', err);
               resolve(false);
             }
           })
        },
        selectFrom(obj) {
            this.fromItemObj = obj
            this.fromId = obj.value
          },

        GetHubFlags() {
          return new Promise((resolve,reject) => {
            try {
              let HubFlagsRVPPayload = {
                  "Outsourceid": 4,
                  "hubid": this.userHubId
              }
              GetHubFlags2(HubFlagsRVPPayload, (result) => {
                  if (result.data.data.code == 200) {
                      this.isRSVSr = result.data.data.data.IsRSVSr
                  } else {
                      this.$alertify.error(result.data.data.message)
                  }
              })
              resolve(true)
            } catch(e) {
              console.log('error logs..', e);
              resolve(true)
            }
          })
        },
        selectClient(obj) {
            this.ClientObj = obj;
            this.Clientname = obj.value
        },
        selectClient2(obj) {
            this.ClientObj2 = obj;
            this.Clientname2 = obj.value
        },
        GetClientList() {
            this.ClientLoader = this.loader;
            let RVPPayload = {}
            ClientNameList(RVPPayload, (result) => {
                this.clientArrayList = result.data.data;
                for (let i = 0; i < this.clientArrayList.length; i++) {
                    this.clientList.push({
                        value: this.clientArrayList[i].ClientMasterID,
                        text: `${this.clientArrayList[i].CompanyName}`
                    })
                }
                this.ClientLoader = '';
            })
        },
        selectServiceType(obj) {
            this.ServiceTypeObj = obj;
            this.ServiceType = obj.text
        },
        GetServiceTypeList() {
            this.ServiceLoader = this.loader;
            let RVPPayload = {
                "serviceTypeValuesRequired": true
            }
            ServiceType1(RVPPayload, (result) => {
                this.ServiceTypeArrayList = result.data.data.serviceType;
                for (let i = 0; i < this.ServiceTypeArrayList.length; i++) {
                    this.ServiceTypeList.push({
                        text: `${this.ServiceTypeArrayList[i]}`
                    })
                }
                this.ServiceLoader = '';
            })
        },
        selectWeightG(obj) {
            this.WeightGObj = obj;
            this.WeightGroup = obj.text
        },
        selectEscalation(obj) {
            this.EscalationObj = obj;
            this.Escalation = obj.value
        },
        GetEscalation() {
            this.EscalationLoader = this.loader;
            let RVPPayload = {}
            GetEscalation(RVPPayload, (result) => {
                this.EscalationListArrayList = result.data.data;
                for (let i = 0; i < this.EscalationListArrayList.length; i++) {
                    this.EscalationList.push({
                        text: `${this.EscalationListArrayList[i]}`
                    })
                }
                this.EscalationLoader = '';
            })
        },

        selectCluster(obj) {
            this.ClusterObj = obj;
            this.ClusterId = obj.value
        },
        validateEODAllocation() {
            let EODvalidationdata = {
                "DeliveryUserID": this.SrId,
                "HubID": this.userHubId
            }
            EODValidation(EODvalidationdata, (result) => {
                console.log('validationResult', result);
                if (result.data.code === 202) {
                    this.hideAllocateFlag = false
                    this.$alertify.error(result.data.message);
                }else{
                    this.hideAllocateFlag=true;
                    this.PassEOD = true
                  }
                this.TopReset = false

            })
        },
        ValiadteTripdetails() {
            let TripDetailsRVPPayload = {
                "XBkey": "XB123",
                "HubId": this.userHubId,
                "DeliveryUserId": this.SrId
            }
            GetTripdetails(TripDetailsRVPPayload, (result) => {
                if (result.data.TripState == "closed") {
                    this.tripState = 'created'
                    this.startTripFlag = true
                    this.$alertify.error(result.data.message)
                    this.SRSelectingloader = false;
                } else if (result.data.TripState == "created" || result.data.TripState == "start") {
                    this.tripCreatedDate = moment(result.data.TripCreatedDateTime).format('DD-MM-YYYY');
                    this.currentDateTime = moment(result.data.CurrentDateTime).format('DD-MM-YYYY');
                    if (this.tripCreatedDate == this.currentDateTime) {
                        this.tripDayflag = 0;
                        this.tripDateFlag = false;
                    } else {
                        this.tripDayflag = result.data.tripDayflag
                        this.tripDateFlag = true;
                    }
                    this.startTripFlag = true
                    this.tripState = result.data.TripState
                    this.tripTitle = "Continue trip"
                    this.$alertify.error(result.data.message)
                    this.SRSelectingloader = false;
                } else if (result.data.TripState == "deliveryuserclosed" && result.data.code == 200) {
                    this.openKM = result.data.OpenKM
                    this.openKmImg = result.data.OpenKMImageUrl
                    this.closeKmImg = result.data.CloseKMImagUrl
                    this.originCloseImg = result.data.CloseKMImagUrl
                    this.tripId = result.data.TripId
                    this.srVehicleNo = result.data.VehicleNo
                    this.openKm = result.data.OpenKM
                    this.closeTripModel = true
                    this.SRSelectingloader = false;
                } else {
                    this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message')
                }
            }, error => {
                console.error(error)
            })
        },
        startTrip() {
            this.errVehicleNo = ""
            this.errVehicleKm = ""
            if (this.tripTitle == 'Start Trip') {
                this.vehicleTypeFlag = true
            } else {
                this.startAllocation(false)
            }
        },
        selectVehicleNo(obj) {
            this.vehicleNoItemObj = obj
            this.vehicleNo = obj.text
            this.vehicleVendorId = obj.value
        },
        loadVehicleDetails(type) {
            this.isVehicleReplacedCheck = 0
            this.isVehicleReplaced = false
            this.errVehicleNo = ""
            this.errVehicleKm = ""
            this.startAllocationFlag = false
            this.vehicleType = type
            this.srVehicleList = []
            this.vehicleNoItemObj = {
                value: '',
                text: ''
            }
            this.vehicleOpenKM = ''
            this.vehicleNo = ''
            this.vehicleVendorId = 0
            if(type=="bike") {
                let payload = {
                  "srid":this.SrId,
                  "hubid":this.userHubId
                }
                BikeVehicleList(payload, (result) => {
                    if (result.data.data.ResultCode == 100) {
                        var srVehicleList = result.data.data.data
                        for (var i = 0; i < srVehicleList.length; i++) {
                          this.srVehicleList.push({value:srVehicleList[i].VehicleNumber,text:srVehicleList[i].VehicleNumber})
                        }
                    }
                })
              } else if(type=="vehicle") {
            let payload = {
                "HubId": this.userHubId
            }
            VehicleList(payload, (result) => {
                if (result.data.data.ResultCode == 100) {
                    if (type == "vehicle") {
                        var srVehicleList = result.data.data.Data
                        for (var i = 0; i < srVehicleList.length; i++) {
                            this.srVehicleList.push({
                                value: srVehicleList[i].VendorVehicleId,
                                text: srVehicleList[i].VehicleNumber
                            })
                        }
                    }
                }
            })
        }
        },
        isVehicleReplaceCheck(event) {
            this.vehicleNoItemObj = {
                value: '',
                text: ''
            }
            this.vehicleNo = ''
            this.vehicleVendorId = 0
            if (event == 1) {
                this.isVehicleReplaced = true
            } else {
                this.isVehicleReplacedCheck = 0
                this.isVehicleReplaced = false
            }
        },
        startAllocation(flag) {
            this.flagShowPreviousShipment = false
            this.startAllocationFlag = false
            this.errVehicleNo = ""
            this.errVehicleKm = ""
            var decimal = /^\d+(\d{1,2})?$/;
            if (decimal.test(this.vehicleOpenKM) == false && this.vehicleNoRegExp.test(this.vehicleNo.toUpperCase()) == false && flag && this.vehicleVendorId == 0) {
                this.errVehicleNo = "Enter Correct Vehicle No"
                this.errVehicleKm = "Enter Correct KM"
            } else if (this.vehicleNoRegExp.test(this.vehicleNo.toUpperCase()) == false && flag && this.vehicleVendorId == 0) {
                this.errVehicleNo = "Enter Correct Vehicle No"
            } else if (decimal.test(this.vehicleOpenKM) == false && flag) {
                this.errVehicleKm = "Enter Correct KM"
            } else if (flag && this.vehicleOpenKM > 1000000) {
                this.errVehicleKm = "Open Km should be less than 1000000"
            } else {
                this.startAllocationFlag = true
                if (flag) {
                    this.TripCreation();
                }
            }
        },
        TripCreation() {
            this.allocationLoader = true;
            let RVPPayload = {
                "XBkey": "XB123",
                "sruserid": this.SrId.toString(),
                "hubid": this.userHubId,
                "km": this.vehicleOpenKM ? this.vehicleOpenKM : 0,
                "tripstate": this.tripState, //"created",
                "vehicleno": this.vehicleNo.toUpperCase(),
                "vehicletype": this.vehicleType,
                "triptype": "RVP",
                "srname": this.SrName,
                "isvehiclereplaced": this.isVehicleReplaced,
                "operationType": "lastmile"
            }
            if ((this.vehicleType == 'bike' && this.srVehicleList.length == 0) || this.isVehicleReplaced == true) {
                RVPPayload['isvehicleupdated'] = true
            } else {
                RVPPayload['isvehicleupdated'] = false
            }
            if (this.vehicleType == 'vehicle') {
                RVPPayload['vehiclevendorid'] = this.vehicleVendorId
            }
            CreateTrip(RVPPayload, (result) => {
                if (result.data.code == 200) {
                    let TrackerInfo = {
                        projectname: "Last Mile",
                        type: "Web",
                        userid: this.userid,
                        username: this.createdBy,
                        meta: {
                            "event": "createTrip",
                            "srname": this.SrName,
                            "triptype": "RVP",
                            "hubid": this.userHubId
                        }
                    }
                    this.PageTracker(TrackerInfo);
                    this.startAllocationFlag = true;
                    this.$alertify.success(result.data.message);

                } else if (result.data.code == 202) {
                    this.startAllocationFlag = false;
                    this.$alertify.error(result.data.message.details[0].message);
                } else {
                    this.startAllocationFlag = false;
                    this.$alertify.error(result.data.message);
                }
                this.allocationLoader = false;
            }, error => {
                this.startAllocationFlag = false;
                this.$alertify.error('Failed to Create Trip, Please retry!');
                this.allocationLoader = false;
                console.error(error)
            })
        },
        isVehicleReplaceCheck(event) {
            this.vehicleNoItemObj = {
                value: '',
                text: ''
            }
            this.vehicleNo = ''
            this.vehicleVendorId = 0
            if (event == 1) {
                this.isVehicleReplaced = true
            } else {
                this.isVehicleReplacedCheck = 0
                this.isVehicleReplaced = false
            }
        },
        loadOpenImageError(imageSrc, type) {
            var srcLink = "static/img/defaultImg.png"
            this.openKmImg = srcLink
        },
        loadCloseImageError(imageSrc) {
            var srcLink = "static/img/defaultImg.png"
            this.originCloseImg = imageSrc
            this.closeKmImg = srcLink
        },
        verifyTrip() {
            if (this.openKm >= 1000000) {
                this.errorOpenKM = "Open Km should be less than 1000000";
            } else {
                this.errorOpenKM = '';
                if (parseFloat(this.closeKm) > parseFloat(this.openKm)) {
                    let calculatekm = parseFloat(this.closeKm) - parseFloat(this.openKm);
                    if (calculatekm < 200) {
                        this.errorCloseKM = '';
                        let RVPPayload = {
                            "XBkey": "XB123",
                            "tripid": this.tripId,
                            "sruserid": this.SrId.toString(),
                            "hubid": this.userHubId,
                            "km": this.closeKm,
                            "Openkm": this.openKm,
                            "tripstate": "closed",
                            "vehicleno": this.srVehicleNo,
                            "isvehiclereplaced": false,
                            "lastmodifiedby": this.createdBy,
                            "operationType": "lastmile"
                        }
                        CloseTrip(RVPPayload, (result) => {
                            if (result.data.code == 200) {
                                let TrackerInfo = {
                                    projectname: "Last Mile",
                                    type: "Web",
                                    userid: this.userid,
                                    username: this.createdBy,
                                    meta: {
                                        "event": "closeTrip",
                                        "tripid": this.tripId,
                                        "sruserid": this.SrId.toString()
                                    }
                                }
                                this.PageTracker(TrackerInfo);
                                this.$alertify.success(result.data.message)
                                this.closeTripModel = false
                            } else {
                                this.$alertify.error(result.data.message)
                            }
                        })
                    } else {
                        this.errorCloseKM = "Travel distance cannot be more than 200 KM/day.!";
                    }
                } else {
                    this.errorCloseKM = "Close KM should be greater then open KM"
                }
            }
        },
        closeCloseTripModel() {
            this.closeTripModel = false
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        countDownChangedSuccess(dismissCountDownSuccess) {
            this.dismissCountDownSuccess = dismissCountDownSuccess
        },
        selectReason(obj) {
            this.ReasonObj = obj;
            this.Reason = obj.text
        },
        CheckPDD() {
            this.CloseNonAllocationRsn()
            let Payload = {
                "DeliveryUserId": this.SrId,
                "HubId": this.userHubId.toString(),
                "shipmenttype": "RVP",
            }
            GetNonAllocationSEQ(Payload, (result) => {
                if (result.data.code == 200 && result.data.data.length > 0) {
                    this.SeqArray = result.data.data.filter(x => (x.result != 0))
                    this.BucketName = this.SeqArray[0].Bucket
                    this.TitleName = this.SeqArray[0].title
                    this.resultCount = this.SeqArray[0].result
                    this.SEQShippingids = this.SeqArray[0].shippingids
                    this.arrReasonList = this.SeqArray[0].Reason.split(",")
                    for (let i = 0; i < this.arrReasonList.length; i++) {
                        this.ReasonList.push({
                            text: this.arrReasonList [i],
                        })
                    }
                    this.NonAllocationRsn = true
                } else {
                    this.confirmTrip();
                    this.CloseNonAllocationRsn()
                }
            })
        },
        StoreNonAllocationSeq() {
            this.CloseNonAllocationRsn();
                this.TitleName = this.SeqArray[0].title
                this.BucketName = this.SeqArray[0].Bucket
                this.resultCount = this.SeqArray[0].result
                this.SEQShippingids = this.SeqArray[0].shippingids
                 this.arrReasonList  = this.SeqArray[0].Reason.split(",")
                for (let i = 0; i < this.arrReasonList .length; i++) {
                    this.ReasonList.push({
                        text: this.arrReasonList [i],
                    })
                }
            this.NonAllocationRsn = true
        },
        CloseNonAllocationRsn() {
            this.BucketName = ''
            this.TitleName =''
                        this.Reason = ''
            this.ReasonObj = {
                text: ""
            }
            this.resultCount = 0,
            this.SEQShippingids =[]
            this.ReasonList = []
            this.NonAllocationRsn = false
        },
        SubmitNonAllocationRsn() {
            let Payload = {
                "DeliveryUserId": this.SrId,
                "Reason": this.Reason,
                "Bucket": this.BucketName,
                "CreatedBy": this.createdBy,
                "shippingids": this.SEQShippingids,
                "pendingcount": this.resultCount
            }
            StoreReason(Payload, (result) => {
                if (result.data.code == 200) {
                    this.$alertify.success("Reason Submitted Successfully!!")
                    this.CloseNonAllocationRsn();
                    this.SeqArray.splice(0, 1)
                    if(this.SeqArray.length>0){
                        this.StoreNonAllocationSeq();
                    }
                    else{
                        this.confirmTrip();
                    }
                } else if(result.data.code == 204){
                   this.$alertify.error('Reason is required.')
                }
            })
        },
        async confirmTrip() {
            this.allocationSuccessMsg = ''
            this.isConfirmLoad = true;
            this.showParentGroupIdShipmentList = [];
            let RVPPayload = {
                "XBkey": "XB123",
                "sruserid": this.SrId.toString(),
                "hubid": this.userHubId,
                "km": this.vehicleOpenKM ? this.vehicleOpenKM : 0,
                "tripstate": this.tripState, //"created",
                "vehicleno": this.vehicleNo.toUpperCase(),
                "vehicletype": this.vehicleType,
                "triptype": "RVP",
                "srname": this.SrName,
                "isvehiclereplaced": this.isVehicleReplaced,
                "LastModifiedBy": this.createdBy,
                "MarkedFrom":this.fromId,
                "operationType": "lastmile",
                "isHandoverDeliveryUser": 1
            }
            if ((this.vehicleType == 'bike' && this.srVehicleList.length == 0) || this.isVehicleReplaced == true) {
                RVPPayload['isvehicleupdated'] = true
            } else {
                RVPPayload['isvehicleupdated'] = false
            }
            if (this.vehicleType == 'vehicle') {
                RVPPayload['vehiclevendorid'] = this.vehicleVendorId
            }
            ConfirmShipment(RVPPayload, (result) => {
                if (result.data.code == 200) {
                    let TrackerInfo = {
                        projectname: "Last Mile",
                        type: "Web",
                        userid: this.userid,
                        username: this.createdBy,
                        meta: {
                            "event": "confirmShipment",
                            "sruserid": this.SrId.toString(),
                            "km": this.vehicleOpenKM ? this.vehicleOpenKM : 0,
                            "triptype": "RVP",
                            "srname": this.SrName,
                            "isvehiclereplaced": this.isVehicleReplaced,
                            "MarkedFrom":this.fromId,
                        }
                    }
                    this.PageTracker(TrackerInfo);
                    this.isAllocation = false
                    this.$alertify.success(result.data.message)
                    this.AllocatedFwdShipmentData();
                    this.loadAllocatedShipmentListInHub();
                    this.fromId = "UA";
                    this.errorRvpAllocation = "";
                    this.successRvpAllocation = '';
                    this.errorRvpAllocationErrorArrobj = [];
                    } else {
                    if (result.data.status == 208) {
                        this.showGroupIdShipmentModel = true;
                        this.pendingGrouptErrorMsg = result.data.message;
                        this.showParentGroupIdShipmentList = result.data.data;
                    } else {
                        this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message.')
                    }
                }
                this.isConfirmLoad = false;
            }, error => {
                console.error(error)
                this.isConfirmLoad = false;
            })
        },
        srAllocatedPagination(pageNum) {
          this.srallocatePageNumber = pageNum;
          this.AllocatedFwdShipmentData();
        },
        AllocatedFwdShipmentData() {
            this.isAllocation = false
            this.AllocateTableLoader = true
            this.AllocatedList = []
            this.srAllocatedTotalCount = 0
            let AllocatedShipmentRVPPayload = {
                "HubId": (this.userHubId).toString(),
                "ShipmentType": "RVP",
                "DeliveryUserId": this.SrId,
                "pageNumber": this.srallocatePageNumber,
                "pageLimit": this.srAllocatedPageLimit
            }
            AllocatedFwdShipmentDetails(AllocatedShipmentRVPPayload, (result) => {

                if(result.status == 200 && result.data.code == 200) {
                  this.AllocatedList = result.data.data.rows
                  this.srAllocatedTotalCount = result.data.data.count;
                  if(this.AllocatedList.length>0){
                    this.isAllocation = true
                }
                  if (this.srAllocatedTotalCount < this.srAllocatedPageLimit) {
                    this.srAllocatedPageCount = 1
                  } else {
                    this.srAllocatedPageCount = Math.ceil(this.srAllocatedTotalCount / this.srAllocatedPageLimit);
                  }
                  this.AllocateTableLoader = false
                } else if(result.status == 200 && result.data.code != 200) {
                  this.srAllocatedTotalCount = 0
                  this.srAllocatedPageCount = 1
                  this.AllocateTableLoader = false
                } else if(result.status != 200) {
                  this.srAllocatedTotalCount = 0
                  this.srAllocatedPageCount = 1
                  this.AllocateTableLoader = false
                }
            })
        },
        loadAllocatedShipmentListInHub() {
            this.HUbAllocatedTableLoader=true
          return new Promise((resolve, reject) => {
            try {
              this.showAllocatedShipmentsList = []
              this.hubAllocatedTotalCount = 0
              let reqAllocateRVPPayload = {
                  "HubId": (this.userHubId).toString(),
                  "ShipmentType": "RVP",
                  "pageNumber": this.huballocatePageNumber,
                  "pageLimit": this.hubAllocatedPageLimit
              }

              AllocatedFwdShipmentDetails(reqAllocateRVPPayload, (result) => {
                if(result.status == 200 && result.data.code == 200) {
                  this.showAllocatedShipmentsList = result.data.data.rows
                  this.hubAllocatedTotalCount = result.data.data.count;

                  if (this.hubAllocatedTotalCount < this.hubAllocatedPageLimit) {
                    this.hubAllocatedPageCount = 1
                  } else {
                    this.hubAllocatedPageCount = Math.ceil(this.hubAllocatedTotalCount / this.hubAllocatedPageLimit);
                  }
                  this.HUbAllocatedTableLoader=false
                } else if(result.status == 200 && result.data.code != 200) {
                  this.hubAllocatedTotalCount = 0
                  this.hubAllocatedPageCount = 1
                  this.HUbAllocatedTableLoader=false
                } else if(result.status != 200) {
                  this.hubAllocatedTotalCount = 0
                  this.hubAllocatedPageCount = 1
                  this.HUbAllocatedTableLoader=false
                }
              })
            } catch(e) {
              resolve(false)
            }
          });
        },
        hubAllocatedPagination(pageNum) {
          this.huballocatePageNumber = pageNum;
          this.loadAllocatedShipmentListInHub();
        },
        RemoveShipment(shippingId) {
            let RVPPayload = {
                XBkey: "XB123",
                ShippingID: shippingId,
                LastModifiedBy: this.createdBy,
            }
            RemoveAllocatedShipment(RVPPayload, (result) => {
                if (result.data.code == 200) {
                    let TrackerInfo = {
                        projectname: "Last Mile",
                        type: "Web",
                        userid: this.userid,
                        username: this.createdBy,
                        meta: {
                            "event": "RemoveShipment",
                            "ShippingID": shippingId.toString()
                        }
                    }
                    this.PageTracker(TrackerInfo);
                    this.AllocatedFwdShipmentData();
                    this.loadAllocatedShipmentListInHub();
                    this.loadUnallocatedShipmentsList();
                    this.$alertify.success("Shipment Successfully Removed")
                } else {
                    this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message.')
                }
            }, error => {
                console.error(error)
            })
        },

        PreviousDayShipmentList() {
            this.PDTableLoader = true;
            this.SuggestionList = [];
            if(this.SrId == ''){
                this.PDTableLoader = false;
                }
            let PreviousDayRVPPayload = {
                "HubId": (this.userHubId).toString(),
                "DeliveryUserId": this.SrId,
                "shipmenttype": "RVP",
            }
            PreviousDayShipmentDetails(PreviousDayRVPPayload, (result) => {
                this.SuggestionList = result.data.data
                this.PDTableLoader = false;
            })
            this.PDTableLoader = false;
        },
        SameRouteShipmentList() {
            this.SMTableLoader = true
            this.SameRouteList = [];
            if(this.SrId == ''){
                this.SMTableLoader = false;
                }
            let SameRouteRVPPayload = {
                "DeliveryUserId": this.SrId,
                "HubId": (this.userHubId).toString(),
                "shipmenttype": "RVP",
            }
            SameRouteShipments(SameRouteRVPPayload, (result) => {
                this.SameRouteList = result.data.data
                this.SMTableLoader = false;
            })
            this.SMTableLoader = false;
        },
        HandleDragOver(event) {
            event.preventDefault();
        },
        OnlyNumber: function ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 8 && keyCode !== 44) {
                $event.preventDefault();
            }
        },
        OpenPrintShipmentModal() {
            this.PrintShipmentModal = true
            this.EnableHyperLink = false
        },
        closePrintShipmentModal() {
            this.batchCreatedDate = '',
                this.PrintShipmentModal = false,
                this.isLoadBatch = false,
                this.isLoadPDF = false,
                this.ShowPrintTable = false,
                this.EnableHyperLink = false
        },
        ResetPrintShipmentModal() {
            this.batchCreatedDate = '',
                this.PrintShipmentsList = [],
                this.isLoadBatch = false,
                this.isLoadPDF = false,
                this.ShowPrintTable = false,
                this.EnableHyperLink = false
        },
        GetShipmentPrintdetails() {
            this.PrintShipmentDetails();
            this.ShowPrintTable = true
        },
        PrintShipmentDetails() {
            this.PrintShipmentsList = [];
            this.isLoadBatch = true;
            let batchCdate = moment(this.batchCreatedDate).format('YYYY-MM-DD');
            this.today = new Date();
            let Today = moment(this.today).format('YYYY-MM-DD');
            if (batchCdate == Today) {
                this.EnableHyperLink = true;
            }
            let batchRVPPayload = {
                "UserHubID": this.userHubId.toString(),
                "DeliveryUserID": this.SrId,
                "shipmentType": "RVP",
                "createdDate": batchCdate
            }
            ShipmentPrintDetails(batchRVPPayload, (result) => {
                if (result.data.code == 200) {
                    this.isLoadBatch = false
                    for (var i = 0; i < result.data.PrintBatchId.length; i++) {
                        this.shippingIDArray = []
                        for (var j = 0; j < result.data.PrintBatchId[i].NoOfShipments; j++) {
                            this.shippingIDArray.push({
                                shippingIDArray: result.data.PrintBatchId[i].ShippingIDs[j].ShippingID
                            })
                            this.ResCreatedDate = moment(result.data.PrintBatchId[i].ShippingIDs[j].CreatedDate).format('DD-MM-YYYY')
                        }
                        this.PrintShipmentsList.push({
                            AssignBatchNo: result.data.PrintBatchId[i].AssignBatchNo,
                            NoOfShipments: result.data.PrintBatchId[i].NoOfShipments,
                            shippingIDArray: this.shippingIDArray,
                            SrName: this.SrName,
                            CreatedDate: this.ResCreatedDate
                        })
                    }
                } else {
                    this.isLoadBatch = false
                    this.$alertify.error(result.data.message)
                }
            }, error => {
                console.error(error)
            })
        },
        exportCSVOfShippingIDS(result) {
            let csvContent = "data:text/csv;charset=utf-8,";
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();
            var today = dd + "" + mm + "" + yyyy;
            let filename = "ShippingID" + today + ".csv";
            csvContent += ['ShippingID',
                    ...result.map(item => Object.values(item).join(";"))
                ]
                .join("\n")
                .replace(/(^\[)|(\]$)/gm, "");

            const data = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", filename);
            link.click();
        },

        PrintShipment(AssignBatchNo) {
            this.isLoadPDF = true
            this.input = {
                "DeliveryUserID": this.SrId,
                "ShipmentType": "RVP",
                "BatchId": AssignBatchNo,
                "PrintType": "RVP",
                "UserName": this.createdBy,
                "PrintFrom": 'FromWeb'
            }
            pdfData(this.input, (result) => {
                if (result.status == 200) {
                    const downloadUrl = window.URL.createObjectURL(new Blob([result.data], {
                        type: 'application/pdf'
                    }))
                    let message = {
                        title: '',
                        body: `<p>Pdf is generated, Would you like to open.!</p>`,
                    };

                    let res = this.$dialog.alert(message, {
                            html: true,
                            animation: 'bounce',
                            backdropClose: false,
                            loader: true
                        })
                        .then(dialog => {
                            window.open(downloadUrl);
                            this.isLoadPDF = false
                            dialog.close();
                        })
                        .catch(() => {
                            this.isLoadPDF = false
                        })
                } else {
                    this.isLoadPDF = false;
                    this.$alertify.error('Unable to load pdf, Please try after sometime.!');
                }
            }, error => {
                this.isLoadPDF = false;
                console.error(error)
            })
        },
        GetCount() {
            this.CountLoading= true;
              let RVPPayload = {
                  "shipmenttype": "RVP",
                  "hubid": this.userHubId.toString()
              }
              GetShipmentCount(RVPPayload, (result) => {
                  let CountARR = [];
                  if(result.data.code == 200){
                      CountARR = result.data.data[0]
                      this.AllCount = CountARR.all
                      this.tobeAttemptedTodayCount = CountARR.tobeAttemptedToday
                      this.pddBreachedCount = CountARR.pddBreached
                      this.PDDBreachedinNext24hrsCount = CountARR.PDDBreachedinNext24hrs
                      this.fakeAttemptsCount = CountARR.fakeAttempts
                      this.CountLoading= false;
                  }
                  else{
                    this.CountLoading= false;
                    this.$alertify.error(result.data.message != '' && result.data.message != undefined ? result.data.message : 'Not getting any response message')
                  }
              })
        },
        unallocatedgetPaginationData(pageNum) {
            this.unallocatePageNumber = pageNum;
            this.loadUnallocatedShipmentsList();
        },
        async GetCurrentScreenValue(currentVal) {
            console.log("currentValllllllll", currentVal);
            this.currentScreenTab = currentVal;
            if (this.currentScreenTab == 'PDDBreached') {
                this.Pddbreached = true;
                this.IsAllData = false;
                this.Tobeattempted = false;
                this.Pddbreachedinnext24hours = false;
                this.FakeAttempt = false;
            } else if (this.currentScreenTab == 'TobeAttemptedToday') {
                this.Tobeattempted = true;
                this.IsAllData = false;
                this.Pddbreached = false;
                this.Pddbreachedinnext24hours = false;
                this.FakeAttempt = false;
            } else if (this.currentScreenTab == 'PDDBreachedinNext24hrs') {
                this.IsAllData = false;
                this.Tobeattempted = false;
                this.Pddbreached = false;
                this.Pddbreachedinnext24hours = true;
                this.FakeAttempt = false;
            }
            else if(this.currentScreenTab== 'FakeAttempts'){
                this.FakeAttempt = true;
                this.IsAllData = false;
                this.Tobeattempted = false;
                this.Pddbreached = false;
                this.Pddbreachedinnext24hours = false;
            }
            else {
                this.IsAllData = true;
                this.Tobeattempted = false;
                this.Pddbreached = false;
                this.Pddbreachedinnext24hours = false;
            }
            this.loadUnallocatedShipmentsList();
        },

        loadUnallocatedShipmentsList() {
            let reqRVPPayload = {
                "shipmenttype": "RVP",
                "hubid": this.userHubId,
                "pagenumber": this.unallocatePageNumber,
                "pagelimit": this.unallocatePageLimit,
                "isAllData": this.IsAllData,
                "tobeattempted": this.Tobeattempted,
                "pddbreached": this.Pddbreached,
                "pddbreachedinnext24hours": this.Pddbreachedinnext24hours
            }
            if (this.AccAWBNumbers != "") {
                let shipingID = this.AccAWBNumbers.split(/[\s,]+/);
                let shipmentArray = [];
                $.each(shipingID, (key, AccAWBNumbers) => {
                    if (AccAWBNumbers != '') {
                        shipmentArray.push(AccAWBNumbers.trim())
                    }
                })
                reqRVPPayload.shipmentid = shipmentArray;
            }
            if (this.Clientname) {
                reqRVPPayload.clientid = this.Clientname
            }
            if (this.ServiceType) {
                reqRVPPayload.servicetype = this.ServiceType
            }
            if (this.WeightGroup) {
                reqRVPPayload.weightgroupid = this.WeightGroup
            }
            if (this.ClusterId) {
                reqRVPPayload.clusterid = this.ClusterId
            }
            if (this.Escalation) {
                reqRVPPayload.Escalation = this.Escalation
            }
            if (this.rvpAddress) {
                reqRVPPayload.pincode = this.rvpAddress
            }
              this.getPendingShipmentforAllocation(reqRVPPayload)
        },
        getPendingShipmentforAllocation(RVPPayloadobj) {
            this.IsReload = true;

            this.UATableLoader = true
            this.showUnallocatedList = [];
            this.unallocateTotalCount = [];
            getUnallocatedShipments(RVPPayloadobj, (result) => {
               console.log('VENKY ------------>>', result);
            if(result.status == 200 && result.data.code == 200) {
                    this.showUnallocatedList = result.data.data
                    this.unallocateTotalCount = result.data.totalCount;

                    if (this.unallocateTotalCount < this.unallocatePageLimit) {
                        this.unallocatepageCount = 1
                    } else {
                        this.unallocatepageCount = Math.ceil(this.unallocateTotalCount / this.unallocatePageLimit);
                    }
                    this.UATableLoader = false

            } else if(result.status == 200 && result.data.code != 200) {
                    this.unallocatepageCount = 1
                    this.UATableLoader = false
            } else if(result.status != 200){
                    this.unallocatepageCount = 1
                    this.UATableLoader = false
                }
                this.IsReload = false;

            })
        },
            Reset() {
                this.dismissCountDown = 0,
                this.dismissCountDownSuccess = 0,
                this.TopReset = true,
                this.currentScreenTab = 'ALL',
                this.AllocateTableLoader = false,
                this.shipmentNo = ''
                this.srAllocatedTotalCount = 0
                this.SuggestionList = [],
                    this.SameRouteList = [],
                    this.AllocatedList = [],
                    this.Clientname = ''
                    this.fromId = "UA",
                this.disableprint = false
                this.SrId = ''
                this.SrName = ''
                this.srItemObj = {
                    value: "",
                    text: ""
                }
                this.continueloader = false,
                this.CountLoading = false,
                this.AllocateTableLoader= false,
                this.PDTableLoader=false,
                this.SMTableLoader=false,
                this.currentDateTime = '',
                    this.tripDayflag = '',
                    this.tripCreatedDate = '',
                    this.tripDateFlag = false,
                    this.IsSRNeedTrip = false
                this.isVehicleReplacedCheck = 0
                this.isVehicleReplaced = false
                this.errVehicleNo = ""
                this.errVehicleKm = ""
                this.tripTitle = 'Start Trip'
                this.isRSVSr = 0
                this.startTripFlag = false
                this.vehicleTypeFlag = false
                this.vehicleType = ""
                this.vehicleNoItemObj = {
                    value: '',
                    text: ''
                }
                this.vehicleNo = ''
                this.vehicleVendorId = 0
                this.vehicleOpenKM = ''
                this.startAllocationFlag = false
                this.isAllocation = false
                this.tripId = ''
                this.openKm = ''
                this.openKmImg = ''
                this.closeKm = ''
                this.closeKmImg = ''
                this.originCloseImg = ''
                this.srVehicleNo = ''
                this.errorCloseKM = ''
                this.errorOpenKM = ''
                this.flagShowPreviousShipment = false
                this.PDLoading = false
                this.SMLoading = false
                this.UNLoading = false
                this.SRSelectingloader = false
                this.PDSelectedArr = []
                this.SMSelectedArr = []
                this.AllocateTableLoader= false,
                this.PDTableLoader=false,
                this.SMTableLoader=false,
                this.UATableLoader=false,
                this.HUbAllocatedTableLoader=false,
                this.CountLoading=false
                this.ebnDataLoader = false
                return true;
            },
            RightTabReset(){
                this.ResetLoader = true
                this.currentScreenTab = 'ALL',
                this.IsReload = true;
                this.UASelectedArr = []
                this.selectedItems =[]
                this.IsAllData = true;
                this.HUbAllocatedTableLoader = false,
                this.CountLoading = false
                this.IsAllData = true,
                this.Tobeattempted = false,
                this.Pddbreached = false,
                this.Pddbreachedinnext24hours = false,
                this.FakeAttempt = false
                this.startAllocationFlag = false
                this.Clientname = ''
                this.ClientObj = {
                    value: "",
                    text: ""
                }
                this.ServiceType = ''
                this.ServiceTypeObj = {
                    value: "",
                    text: ""
                }
                this.ClusterId = '',
                this.ClusterObj = {
                        value: "",
                        text: ""
                    },
                this.WeightGroup = ''
                this.WeightGObj = {}
                this.AccAWBNumbers = ""
                this.rvpAddress = ''
                this.dismissCountDown = 0,
                this.dismissCountDownSuccess = 0,
                this.selectedPickupsMore=[]
                this.errorRvpAllocation = "";
                this.successRvpAllocation = '';
                this.errorRvpAllocationErrorArrobj = [];
                this.ShipmentFutureFailedArrObj = [];
                this.ShipmentFailedArrObj = [];
                this.EBNshippingData = []
                this.loadUnallocatedShipmentsList();
                this.ResetLoader = false

            },



    },
};



// WEBPACK FOOTER //
// ./src/views/components/newallocationpage/Reverseallocation/Reverseallocation.js